import { api } from "../../../utils/api";
import { NOTIFICATION_PAGE_SIZE } from "../constants";

const UNREAD_COUNT_FIELDS = [
  "totalUnreadCount",
  "total_unread_count",
  "unreadCount",
  "unread_count",
];

export function readUnreadCount(pagination = {}) {
  const field = UNREAD_COUNT_FIELDS.find((key) => Number.isFinite(pagination?.[key]));
  return field ? pagination[field] : null;
}

function toArray(value) {
  return Array.isArray(value) ? value.filter(Boolean) : [];
}

export async function fetchNotifications({ page = 1, per_page = NOTIFICATION_PAGE_SIZE } = {}) {
  const response = await api.get("notifications/", { params: { page, per_page } });
  const payload = response?.data ?? {};
  const buckets = payload.data ?? {};
  const pagination = payload.pagination ?? {};

  return {
    unreadItems: toArray(buckets.unread_notifications),
    readItems: toArray(buckets.read_notifications),
    pagination,
    nextPage: pagination.hasNext ? (pagination.currentPage ?? page) + 1 : undefined,
  };
}

export async function dismissNotification(notificationId) {
  const response = await api.put(
    "notifications/",
    {},
    {
      params: {
        notification_id: notificationId,
      },
    },
  );

  return response?.data?.data;
}

export async function markAllNotificationsAsRead(notificationId) {
  const response = await api.put(
    "notifications/",
    {},
    {
      params: {
        mark_all_read: true,
      },
    },
  );

  return response?.data;
}

export async function createNotification(body) {
  const response = await api.post("notifications/", body);
  return response?.data;
}
